import { STRIPE, STRIPE_ERROR, CLEAN_STRIPE, CLEAN_STRIPE_ERROR } from '_models/redux/types';

const initialState = {
  loaded: undefined,
  method: undefined,
  payload: undefined,
  status: undefined,
  state: undefined,
};

export default function stripeReducer(state = initialState, action) {
  switch (action.type) {
    case STRIPE:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'success',
      };

    case STRIPE_ERROR:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'error',
      };

    case CLEAN_STRIPE:
      return {
        ...state,
        loaded: false,
        method: undefined,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'success',
      };

    case CLEAN_STRIPE_ERROR:
      return {
        ...state,
        loaded: false,
        method: undefined,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'error',
      };
    default:
      return state;
  }
}
